/* Mi & My product page: gallery, options (variants), subscription (selling plans),
   live button labels, Add To Bag, sticky bar, accordions, review bars. */
(function(){
  if(window.__mmPdp) return; window.__mmPdp = true;
  var MM = window.MM = window.MM || {};
  var pdp = document.querySelector('[data-mm-pdp]');
  var dataEl = document.querySelector('[data-pdp-json]');
  if(!pdp || !dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var money = function(c){ return MM.money ? MM.money(c) : '$' + (c/100).toFixed(2); };
  var short = function(c){ return money(c).replace(/\.00(?=\D*$)/, ''); };
  var form = pdp.querySelector('[data-product-form]');
  var idInput = form.querySelector('[data-variant-input]');
  var planInput = form.querySelector('[data-plan-input]');
  var defaultVariant = +idInput.value;
  var state = { variant: defaultVariant, qty: 1, sub: false, plan: null, planName: '' };

  /* gallery */
  var slides = pdp.querySelectorAll('.gal-main .slide'), thumbs = pdp.querySelectorAll('.thumb');
  thumbs.forEach(function(t, i){
    t.addEventListener('click', function(){
      thumbs.forEach(function(x){ x.classList.remove('active'); }); slides.forEach(function(x){ x.classList.remove('active'); });
      t.classList.add('active'); if(slides[i]) slides[i].classList.add('active');
    });
  });

  function variant(){ return D.variants.filter(function(v){ return v.id === state.variant; })[0] || D.variants[0]; }
  function isLast(){ var v = D.variants; return v.length && v[v.length - 1].id === state.variant; }

  function render(){
    var v = variant(), unit = v.price;
    if(state.sub && state.plan && v.plans[state.plan] != null) unit = v.plans[state.plan];
    var wasU = v.compare > v.price ? v.compare : v.price;
    /* pack options are a quantity, not a variant, so everything below is the line total */
    /* a pack tier is a different product, so its price rides on the button */
    var sel = pdp.querySelector('.opt[data-qty].sel');
    var isPack = !!(sel && sel.dataset.packVariant);
    var price = isPack ? +sel.dataset.packPrice : unit * state.qty;
    var was = isPack ? Math.max(+sel.dataset.packWas || 0, price) : wasU * state.qty;
    var saved = was - price;
    var opt = packName() || (D.single ? '' : v.title);
    var label = (D.single ? (D.atcSingle || D.atc) : D.atc).replace('[option]', opt).replace('[price]', money(price));
    var btn = form.querySelector('[data-atc]');
    btn.disabled = isPack ? sel.hasAttribute('disabled') : !v.available;
    form.querySelector('[data-atc-label]').textContent = btn.disabled ? D.soldOut : label;
    var sub = state.sub ? D.subSave.replace('[saved]', short(saved)).replace('[plan]', state.planName)
                        : (saved > 0 ? D.saveToday.replace('[saved]', short(saved)) : D.oneTime);
    form.querySelector('[data-atc-sub]').textContent = sub;

    var fill = form.querySelector('[data-ship-fill]'), msg = form.querySelector('[data-ship-msg]');
    var free = D.freeShip && price >= D.freeShip;
    if(fill && D.freeShip){
      fill.style.width = free ? '100%' : Math.min(100, price / D.freeShip * 100) + '%';
      msg.innerHTML = free ? D.shipDone : (isLast() ? D.shipMoreLast : D.shipMore).replace('[amount]', short(D.freeShip - price));
    }
    var pay = document.querySelector('[data-pay-note]');
    if(pay){
      var ship = free ? D.payFree : D.payPaid.replace('[free_shipping_threshold]', short(D.freeShip));
      pay.innerHTML = D.payNote.replace('[installment]', money(Math.round(price / 4))).replace('[shipping]', ship);
    }
    var sp = document.querySelector('[data-sa-price]'), sq = document.querySelector('[data-sa-qty]');
    if(sp) sp.textContent = money(price);
    if(sq) sq.textContent = opt ? 'for ' + opt.toLowerCase() : '';
    idInput.value = v.id;
    planInput.disabled = !(state.sub && state.plan);
    planInput.value = state.sub && state.plan ? state.plan : '';
  }

  function packName(){
    var sel = pdp.querySelector('.opt[data-qty].sel');
    var n = sel && sel.querySelector('.opt-name');
    return n ? n.textContent.trim() : '';
  }
  pdp.querySelectorAll('.opt[data-qty]').forEach(function(o){
    o.addEventListener('click', function(){
      pdp.querySelectorAll('.opt').forEach(function(x){ x.classList.remove('sel'); x.setAttribute('aria-checked', 'false'); });
      o.classList.add('sel'); o.setAttribute('aria-checked', 'true');
      /* a pack tier buys one of its own SKU; everything else is N of this product */
      if(o.dataset.packVariant){ state.variant = +o.dataset.packVariant; state.qty = 1; }
      else { state.variant = defaultVariant; state.qty = Math.max(1, parseInt(o.dataset.qty, 10) || 1); }
      render();
    });
  });
  (function(){
    var sel = pdp.querySelector('.opt[data-qty].sel'); if(!sel) return;
    if(sel.dataset.packVariant){ state.variant = +sel.dataset.packVariant; state.qty = 1; }
    else state.qty = Math.max(1, parseInt(sel.dataset.qty, 10) || 1);
  })();

  pdp.querySelectorAll('.opt[data-variant]').forEach(function(o){
    o.addEventListener('click', function(){
      pdp.querySelectorAll('.opt').forEach(function(x){ x.classList.remove('sel'); x.setAttribute('aria-checked', 'false'); });
      o.classList.add('sel'); o.setAttribute('aria-checked', 'true');
      state.variant = +o.dataset.variant;
      var u = new URL(location.href); u.searchParams.set('variant', state.variant); history.replaceState(null, '', u);
      render();
    });
  });

  var tgl = pdp.querySelector('[data-sub-toggle]'), freq = pdp.querySelector('[data-freq]');
  function pickPlan(b){
    freq.querySelectorAll('.freq-opt').forEach(function(x){ x.classList.remove('sel'); });
    b.classList.add('sel'); state.plan = b.dataset.plan;
    var n = b.querySelector('b'); state.planName = n ? 'every ' + n.textContent.toLowerCase() : '';
  }
  if(tgl && freq){
    var first = freq.querySelector('.freq-opt'); if(first) pickPlan(first);
    tgl.addEventListener('click', function(){
      state.sub = !state.sub;
      tgl.classList.toggle('on', state.sub); tgl.setAttribute('aria-pressed', String(state.sub));
      freq.hidden = !state.sub; render();
    });
    freq.querySelectorAll('.freq-opt').forEach(function(b){ b.addEventListener('click', function(){ pickPlan(b); render(); }); });
  }

  function add(){
    var item = { id: state.variant, quantity: state.qty };
    if(state.sub && state.plan) item.selling_plan = +state.plan;
    var btn = form.querySelector('[data-atc]'); btn.disabled = true;
    (MM.addToBag ? MM.addToBag([item]) : Promise.reject()).catch(function(){ form.submit(); }).then(function(){ btn.disabled = false; render(); });
  }
  form.addEventListener('submit', function(e){ e.preventDefault(); add(); });
  var stickyBtn = document.querySelector('[data-sticky-btn]');
  if(stickyBtn) stickyBtn.addEventListener('click', add);

  /* sticky bar appears once the main button scrolls away, and lifts the back-to-top button */
  var sticky = document.querySelector('[data-sticky-atc]'), atc = form.querySelector('[data-atc]');
  if(sticky && atc && 'IntersectionObserver' in window){
    new IntersectionObserver(function(es){
      es.forEach(function(e){
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('show', show);
        document.documentElement.style.setProperty('--mm-sticky-offset', show ? (sticky.offsetHeight + 6) + 'px' : '0px');
      });
    }, { threshold: 0 }).observe(atc);
  }

  render();
})();

/* accordions (buy box and FAQ bands) and review bars — anywhere on the page */
(function(){
  if(window.__mmAcc) return; window.__mmAcc = true;
  document.addEventListener('click', function(e){
    var h = e.target.closest('.acc-head'); if(!h) return;
    var item = h.parentElement, body = h.nextElementSibling, open = item.classList.contains('open');
    item.parentElement.querySelectorAll('.acc-item.open').forEach(function(o){ o.classList.remove('open'); o.querySelector('.acc-body').style.maxHeight = null; });
    if(!open){ item.classList.add('open'); body.style.maxHeight = body.scrollHeight + 'px'; }
  });
  if(!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.style.width = e.target.dataset.w + '%'; io.unobserve(e.target); } });
  }, { threshold: 0.4 });
  document.querySelectorAll('.bar-fill[data-w]').forEach(function(b){ io.observe(b); });
})();
